/** Detect video posts from CDN URL (R2 path usually keeps original extension). */
export function isVideoUrl(url: string | undefined | null): boolean {
  if (!url || typeof url !== 'string') return false;
  const u = url.trim().split('?')[0].split('#')[0];
  return /\.(mp4|webm|ogg|ogv|mov|m4v|mkv)$/i.test(u);
}
